import { render } from "./institucional.vue?vue&type=template&id=3bca5558"
import script from "./institucional.vue?vue&type=script&lang=js"
export * from "./institucional.vue?vue&type=script&lang=js"

import exportComponent from "/builds/commerce/central/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__